import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TableModule } from 'primeng/table';
import { NgForm } from '@angular/forms';
import { NgModel } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser'
import { forEach } from '@angular/router/src/utils/collection';

//Services
import { DemonstrativoPagamentoService } from './demonstrativo-pagamento.service';

@Component({
  selector: 'app-demonstrativo-pagamento',
  templateUrl: './demonstrativo-pagamento.component.html',
  styleUrls: ['./demonstrativo-pagamento.component.css']
})
export class DemonstrativoPagamentoComponent implements OnInit {  

  //Boolean
  resultFound:              boolean = false;
  loading:                  boolean = false;
  checkboxSintetico:        boolean = false;
  checkboxAnalitico:        boolean = false;
  dataCompetenciaError:     boolean = false;
  tipoDemonstrativoError:   boolean = false;
  resultNotFound:           boolean = false;

  //Number
  tipoDemonstrativo: number; /*{ 1=>Sintético, 2=>Analitíco, 0=>Nenhum }*/

  trustedUrl:                 any; //Usada no Iframe para exibir o PDF
  urlDemonstrativoCompenente: any;

  //String  
  competencia:   string;
  dataFormatada: string;
  meses:         string[] = ["01","02","03","04","05","06","07","08","09","10","11","12"];
  
  onlyNumberPattern = /([0-9])\w+/;
  
  constructor(private DemonstrativoService: DemonstrativoPagamentoService) 
  {     
    this.tipoDemonstrativo = 0;
    this.dataFormatada     = "";  
  }

  ngOnInit() {       
  }

  cbSintetico(): void{
    if(this.checkboxSintetico == true){
      this.checkboxSintetico = true;
      this.checkboxAnalitico = false; 
    }else{
      this.checkboxSintetico = false;
      this.checkboxAnalitico = false; 
    }     
  }

  cbAnalitico(): void{    
    if(this.checkboxAnalitico == true){
      this.checkboxSintetico = false;
      this.checkboxAnalitico = true; 
    }else{
      this.checkboxSintetico = false;
      this.checkboxAnalitico = false; 
    }
  }

  
  /**
   * Verifica se o mês informado existe e se o ano é menor que 1940.
   * Retorna um boolean: True caso o mês e ano estejam correto
   * e False caso o mês ou o ano estejam errados
   */
  private validaDataCompetencia(): boolean{
    //valida mês/ano
    if(this.competencia.length == 0){
      this.dataFormatada = "";
      return false;
    }
    if(        
        !this.meses.some(elem => elem == this.competencia.substring(0, 2))
        ||
        ( parseInt(this.competencia.substring(2, 6)) < 1940 )       
      )
    {
      this.dataFormatada = "";
      return false;
    }
    //formata data
    this.dataFormatada = this.competencia.substring(0, 2) + "/01/" + this.competencia.substring(2, 6);                 
    return true;
  }

  private validaDados(): boolean{
    this.tipoDemonstrativoError = false;
    this.dataCompetenciaError = false;
    if(this.checkboxSintetico == false && this.checkboxAnalitico == false){      
      this.tipoDemonstrativoError = true;     
    }        
    if(!this.validaDataCompetencia()){
      this.dataCompetenciaError = true;
    }
    if(this.tipoDemonstrativoError == true || this.dataCompetenciaError == true){
      return false;
    }    
    return true;        
  }

  private recuperaSintetico(){    
    this.DemonstrativoService.recuperaDemonstrativoPagamentoSintetico(this.dataFormatada).subscribe(
      data => {
        
        this.urlDemonstrativoCompenente = data.data;
        this.loading     = false;
        this.resultNotFound = false;
        this.resultFound = true;
        window.open(this.urlDemonstrativoCompenente);
      },
      erro => {
        this.loading        = false;
        this.resultNotFound = true;
        this.resultFound    = false;
      }
    )
  }//Fim recuperaSintetico()

  private recuperaAnalitico(){
    this.DemonstrativoService.recuperaDemonstrativoPagamentoAnalitico(this.dataFormatada).subscribe(
      data => {

        this.urlDemonstrativoCompenente = data.data;
        this.loading     = false;
        this.resultNotFound = false;
        this.resultFound = true;
        window.open(this.urlDemonstrativoCompenente);
      },
      erro => {
        this.loading        = false;
        this.resultNotFound = true;
        this.resultFound    = false;
      }
    )
  }//Fim recuperaAnalitico()

  public recuperarDemonstrativo(): void {
    this.loading = true;
    if(this.validaDados()){
      if(this.checkboxSintetico == true){
        this.tipoDemonstrativo = 1 //Sintético
      }
      else if(this.checkboxAnalitico == true){
        this.tipoDemonstrativo = 2 //Analítico        
      }else{
        this.tipoDemonstrativo = 0 //nenhum
      }
     
      switch(this.tipoDemonstrativo){
        case 1: //Sintético
          this.recuperaSintetico();
          break;
        case 2: //Analítico
          this.recuperaAnalitico();
          break;
        default:
          this.loading = false;       
      } 
    }//Fim if(this.validaDados())
    else{
      this.loading = false;
    }
  }//Fim recuperarDemonstrativo()

}



// WEBPACK FOOTER //
// ./src/app/components/demonstrativo-pagamento/demonstrativo-pagamento.component.ts